import { useGetUserProfile } from '@leagueplatform/web-common';
import { Dependent } from '#types/dependents.types.ts';

export const useSelectMembersStep = (dependentArray: Dependent[]) => {
  const { data: userProfile, isLoading } = useGetUserProfile();
  const { firstName, lastName } = userProfile?.userProfile ?? {};
  const userId = userProfile?.userId;

  const memberOptions = [
    {
      label: `${firstName} ${lastName}`,
      value: userId || '',
    },
    ...dependentArray.map(
      ({
        firstName: dependentFirstName,
        lastName: dependentLastName,
        dependentId,
      }) => ({
        label: `${dependentFirstName} ${dependentLastName}`,
        value: dependentId,
      }),
    ),
  ];
  return { memberOptions, isLoading };
};
